/**
 * In-memory cache of the last response per list query ("stale-while-revalidate").
 * Reopening a page shows what it showed last time at once while a fresh request
 * runs; the fresh answer then replaces it. Scoped to the session: cleared on
 * sign-out and when the working branch changes, so no other scope's data shows.
 */

const LIMIT = 80
const entries = new Map<string, unknown>()

export function readCache<T>(key: string): T | undefined {
  const value = entries.get(key) as T | undefined
  if (value !== undefined) {
    // Refresh recency: the most recently used entries survive trimming.
    entries.delete(key)
    entries.set(key, value)
  }
  return value
}

export function writeCache<T>(key: string, value: T) {
  entries.delete(key)
  entries.set(key, value)
  while (entries.size > LIMIT) entries.delete(entries.keys().next().value!)
}

export function clearQueryCache() {
  entries.clear()
}
